import axios from "axios";
import type {
  MeterListResponse,
  DashboardResponse,
  TimeSeriesResponse,
  AnomalyResponse,
  LoadProfileResponse,
  ForecastResponse,
  VoltageQualityResponse,
  FrequencyResponse,
  DemandPeakResponse,
  EventLogResponse,
  UptimeReport,
  CompareResponse,
} from "../types";

// TODO: Replace with actual base URL when provided
const api = axios.create({
  baseURL: "/analytics-api/api/v1",
});

//  Meters
export const fetchMeters = () =>
  api.get<MeterListResponse>("/meters/").then((r) => r.data);

export const fetchDashboard = () =>
  api.get<DashboardResponse>("/meters/dashboard").then((r) => r.data);

//  Time-series
export const fetchTimeSeries = (meterId: string, metric: string, days = 7) =>
  api
    .get<TimeSeriesResponse>(`/meters/${meterId}/timeseries`, {
      params: { metric, days },
    })
    .then((r) => r.data);

//  Anomalies
export const fetchAnomalies = (meterId: string, days = 30, zThreshold = 2.5) =>
  api
    .get<AnomalyResponse>(`/meters/${meterId}/anomalies`, {
      params: { days, z_threshold: zThreshold },
    })
    .then((r) => r.data);

//  Load profile
export const fetchLoadProfile = (meterId: string, days = 30) =>
  api
    .get<LoadProfileResponse>(`/meters/${meterId}/load-profile`, {
      params: { days },
    })
    .then((r) => r.data);

//  Forecast
export const fetchForecast = (meterId: string) =>
  api.get<ForecastResponse>(`/meters/${meterId}/forecast`).then((r) => r.data);

//  Voltage quality
export const fetchVoltageQuality = (meterId: string, days = 7) =>
  api
    .get<VoltageQualityResponse>(`/meters/${meterId}/voltage-quality`, {
      params: { days },
    })
    .then((r) => r.data);

//  Frequency
export const fetchFrequency = (meterId: string, days = 7) =>
  api
    .get<FrequencyResponse>(`/meters/${meterId}/frequency`, {
      params: { days },
    })
    .then((r) => r.data);

//  Demand peaks
export const fetchDemandPeaks = (meterId: string, days = 30) =>
  api
    .get<DemandPeakResponse>(`/meters/${meterId}/demand-peaks`, {
      params: { days },
    })
    .then((r) => r.data);

//  Event log
export const fetchEvents = (meterId: string, days = 90) =>
  api
    .get<EventLogResponse>(`/meters/${meterId}/events`, { params: { days } })
    .then((r) => r.data);

//  Uptime
export const fetchUptime = (meterId: string) =>
  api.get<UptimeReport>(`/meters/${meterId}/uptime`).then((r) => r.data);

//  Compare
export const fetchCompare = (days = 7) =>
  api
    .get<CompareResponse>("/meters/compare/all", { params: { days } })
    .then((r) => r.data);

//  Solar
export const fetchSolarExportImport = (meterId: string, days = 30) =>
  api
    .get(`/meters/${meterId}/solar/export-import`, { params: { days } })
    .then((r) => r.data);

export const fetchSolarNetBalance = (meterId: string, days = 30) =>
  api
    .get(`/meters/${meterId}/solar/net-balance`, { params: { days } })
    .then((r) => r.data);

export const fetchSolarTimeline = (meterId: string, days = 30) =>
  api
    .get(`/meters/${meterId}/solar/timeline`, { params: { days } })
    .then((r) => r.data);

export const fetchSolarSelfSufficiency = (meterId: string, days = 30) =>
  api
    .get(`/meters/${meterId}/solar/self-sufficiency`, { params: { days } })
    .then((r) => r.data);
